import confetti from "canvas-confetti";

const sageColors = ["#56776C", "#7A9A8E", "#E6EBE8", "#B5C7C0", "#1C211E"];

export function celebrate(intensity = "normal") {
  const base = intensity === "big" ? 180 : intensity === "small" ? 60 : 100;
  confetti({
    particleCount: base,
    spread: 70,
    startVelocity: 45,
    origin: { x: 0.5, y: 0.4 },
    colors: sageColors,
    scalar: 0.9,
    ticks: 200,
  });
  if (intensity === "big") {
    setTimeout(() => {
      confetti({ particleCount: 80, angle: 60, spread: 55, origin: { x: 0, y: 0.6 }, colors: sageColors });
      confetti({ particleCount: 80, angle: 120, spread: 55, origin: { x: 1, y: 0.6 }, colors: sageColors });
    }, 200);
  }
}
